<div class="uploader">
  <!-- Header -->
  <div class="uploader__header">
    <span class="uploader__title">Import files @if (folderName) {
      <span> into {{ folderName | truncate: 30 }}</span>
    }</span>
    <a class="uploader__download-template"
      href="/assets/area_upload_template_guide.xlsx"
      download="area_upload_template_guide.xlsx"
      type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      >
      <div class="icon icon-download"></div>
      Download Template
    </a>
  </div>

  <div class="horizontal-separator"></div>

  <p class="uploader__info-message">Make sure all files have the same column structure before uploading.</p>
  <!-- Dropzone -->
  <div class="uploader__dropzone" appDragDrop (fileDropped)="onFileDropped($event)">
    <input
      type="file"
      #fileInput
      id="fileInput"
      multiple
      (change)="fileBrowseHandler($event)"
      accept=".xlsx,.csv,.geojson,.kml"
      hidden
      />
      <div [ngClass]="{'icon': true}" class="icon-upload-file"></div>

      <p class="uploader__drop-text">
        Drag and drop or <label for="fileInput" class="uploader__browse">Browse</label> your file
      </p>
    </div>

    <div class="uploader__sub-text">
      <span>Accepted file types: KML, GeoJSON, JSON, CSV, XLSX</span>
      <span>Maximum file size: 100Mb</span>
    </div>

    <!-- File list -->
    @if (files.length) {
      <div class="uploader__file-list">
        <h3 class="file-list-title">Files: </h3>
        @for (file of files; track file; let i = $index) {
          <div class="uploader__file-row">
            <div [ngClass]="{'icon': true}" class="row-file-icon icon-upload-file"></div>
            <div class="uploader__file-name">{{ file.file.name }}</div>
            <div class="uploader__file-size">
              <span>{{ formatBytes(file.file.size) }}</span>
            </div>
            <div class="uploader__file-ext">
              <span>{{ file.file.name.split('.').pop()?.toUpperCase() }}</span>
            </div>
            <div class="uploader__file-actions">
              <button mat-button (click)="deleteFile(i)" type="button" class="remove-file-button">Remove</button>
            </div>
          </div>
        }
      </div>
    }
  </div>
  <div class="uploader__footer">
    <div class="uploader__help">
      <div class="icon icon-help"></div>
      <span>Get Help</span>
    </div>
    <div class="uploader__actions">
      <button (click)="closeMenu.emit()" type="button" class="cancel-button">Cancel</button>
      <button mat-raised-button color="primary" type="button" class="frmg-primary-button" [disabled]="!filesToSendCount" (click)="upload()">Upload files</button>
    </div>
  </div>

